<script lang="ts">
  /** The terms of use, in full (welcome dialog and Settings → About). */
  import { TERMS, TERMS_UPDATED } from '../terms';
</script>

<div class="terms" data-testid="terms-text">
  {#each TERMS as s (s.title)}
    <h4>{s.title}</h4>
    <p>{s.body}</p>
  {/each}
  <p class="updated">Last updated {TERMS_UPDATED}.</p>
</div>

<style>
  .terms {
    font-size: 12.5px;
    line-height: 1.5;
    color: var(--muted);
  }
  h4 {
    margin: 10px 0 2px;
    font-size: 12.5px;
    color: var(--text);
  }
  h4:first-child {
    margin-top: 0;
  }
  p {
    margin: 0;
  }
  .updated {
    margin-top: 10px;
    color: var(--faint);
  }
</style>
